import api from './apis'
import ua from './utils/ua'

export { api, ua }



// WEBPACK FOOTER //
// ./src/common/app.js